import * as irctcForgotUsernameActions from '../actions/irctcForgotUsernameActions';
import { IRCTC_FORGOT_USERNAME_COMPONENTS } from '../utils/RailsSEOConstants';

export const irctcForgotUsernameInitialState = {
  userEmail: null,
  selectedDate: null,
  componentToShow: IRCTC_FORGOT_USERNAME_COMPONENTS.inputForm,
  showErrorInputForm: false,
  submitFailedErrorMessage: ''
};

export const irctcForgotUsernameReducer = (state, action) => {
  if (typeof action !== 'object') {
    return state;
  }
  switch (action.type) {
    case irctcForgotUsernameActions.ACTION_SET_USER_EMAIL_FORGOT_USERNAME: {
      return {
        ...state,
        userEmail: action.data
      };
    }
    case irctcForgotUsernameActions.ACTION_SET_SELECTED_DATE_FORGOT_USERNAME: {
      return {
        ...state,
        selectedDate: action.data
      };
    }
    case irctcForgotUsernameActions.ACTION_SET_COMPONENT_TO_SHOW_FORGOT_USERNAME: {
      return {
        ...state,
        componentToShow: action.data
      };
    }
    case irctcForgotUsernameActions.ACTION_SET_SHOW_ERROR_INPUT_FORM: {
      return {
        ...state,
        showErrorInputForm: action.data
      };
    }
    case irctcForgotUsernameActions.ACTION_SET_SUBMIT_FAILED_ERR_MSG_FORGOT_USERNAME: {
      return {
        ...state,
        submitFailedErrorMessage: action.data
      };
    }
    default: {
      return state;
    }
  }
};
